/**
 * DataAvailability represents the information of the single seat availability.
 * In order to extend it, you can add custom attributes to the single seat
 * @class DataAvailability
 */
export default class DataAvailability {
  /**
   * When constructing an DataAvailability object, you can pass in a more complex object
   * only the properties defined on the object will be cherry picked
   *
   * ```javascript
   * opts = {
   *   available: true,
   *   priceLevel: 1,
   *   attributes: [
   *     'pricecat-1',
   *     'entrydoor-1',
   *     'is-isle-seat'
   *   ]
   * };
   * ```
   * @param {Object} opts
   */
  constructor (opts) {
    opts = opts || {};

    /**
     * Flag the seat if its available
     * @type {Boolean}
     */
    this.available = opts.available;

    /**
     * A seats blocking code
     * @type {Number}
     */
    this.blockingCode = opts.blockingCode;

    /**
     * The price level is used to determine what different prices are assigned to the seat
     * @type {Number} */
    this.priceLevel = opts.priceLevel;

    /**
     * You can add extra attributes to the seat, these will be reflected in the DOM
     * If, for example, you assign:
     * ```javascript
     * opts.attributes = ['is-aisle-seat'];
     * ```
     * It will result in the dom element
     * ```html
     * <circle cx="0" cy="0" data-is-aisle-seat />
     * ```
     *
     * @type {Array<String>} */
    this.attributes = opts.attributes;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/sim/schemas/Availability.js